import {block} from '../utils/cn';

export const b = block('disclosure');

export const DisclosureQa = {
    SUMMARY: 'disclosure-summary',
    DETAILS: 'disclosure-details',
};
